import APIClient from '../services/APIClient';
import { appendInlineParams } from './helper';

export class Auth {
  logout = () => APIClient.post(appendInlineParams('/auth/logout'));
}

export default new Auth();
